




















































import BaseLoading from '@/components/base/BaseLoading.vue';
import BasePagination from '@/components/base/BasePagination.vue';
import { PaginationMixin } from '@/components/base/pagination.mixin';
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import { CourseLicenseTemplateResponse } from '@/jbi-shared/dto/jtms.dtos';
import {
  CourseLicenseTemplateSortColumns,
  TrainerAccreditationSortColumns
} from '@/jbi-shared/types/jtms.types';
import { courseLicenseTemplateSortableHeaders } from '@/store/modules/jtms/course-license-template/course-license-template.const';
import { SortOrder } from '@/store/types/general.types';
import { mixins } from 'vue-class-component';
import { Component, Emit, Prop } from 'vue-property-decorator';
import CourseLicenseTemplateRow from './CourseLicenseTemplateRow.vue';

@Component({
  components: {
    BaseTable,
    BasePagination,
    BaseLoading,
    SortableTableHeader,
    CourseLicenseTemplateRow
  }
})
export default class CourseLicenseTemplateList extends mixins(PaginationMixin) {
  @Prop() items!: CourseLicenseTemplateResponse[];
  @Prop(Number) currentPage!: number;
  @Prop(Number) totalNumberOfPage!: number;
  @Prop(Number) totalCount!: number;
  @Prop(Boolean) isFirstPage!: boolean;
  @Prop(Boolean) isLastPage!: boolean;
  @Prop(Number) startItemIndex!: number;
  @Prop(Number) endItemIndex!: number;
  @Prop(String) sortColumn!: TrainerAccreditationSortColumns;
  @Prop(String) sortOrder!: SortOrder;

  cltRowKey: number = Math.floor(Math.random() * 999);

  get courseLicenseTemplates() {
    return this.items || [];
  }

  get sortableHeaders() {
    return courseLicenseTemplateSortableHeaders;
  }

  get sortColumnEnum() {
    return CourseLicenseTemplateSortColumns;
  }

  get isPaginated() {
    return typeof this.totalNumberOfPage === 'number';
  }

  onClickHeaderColumn(columnName: string) {
    if (this.sortColumn === columnName) {
      return this.$emit('sort', {
        sortColumn: columnName,
        sortOrder:
          this.sortOrder === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC
      });
    }
    this.$emit('sort', {
      sortColumn: columnName,
      sortOrder: SortOrder.DESC
    });
    this.cltRowKey += 1;
  }

  getSortOrderOfColumn(name: string) {
    if (this.sortColumn === name) {
      return this.sortOrder;
    }
    return SortOrder.ASC;
  }

  @Emit('edit-template')
  emitEditEvent(templateToEdit: CourseLicenseTemplateResponse) {
    return templateToEdit;
  }

  @Emit('delete-template')
  emitDeleteEvent(templateToDelete: CourseLicenseTemplateResponse) {
    return templateToDelete;
  }
}
